// Copyright 2019-2020 The MathWorks, Inc.
define([
    'dojo/_base/declare',
    'mw-remote/impl/JsonTransaction',
    'mw-remote/utils/SendMessageUtil'
], function (declare, JsonTransaction, SendMessageUtil) {
    /**
     * Internal private class to send of data to the server
     * This classs makes use of the Utilty file to send the transaction
     */
    return declare([JsonTransaction], {
        /**
         * This method is used to send the data. It fetches iframeProxyClient from the
         * RemoteEndPointsManager and
         * sends the message.
         * @param {object} data - data to send
         * @param {object} endPointName - endPoint to which the data is to be sent
         * @return {*} a promise
         * @private
         */
        _doSend: function (data) {
            return SendMessageUtil.sendPayload(data, this.endPointName);
        }
    });
});
